import * as React from "react"
const RPG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="m34.338 11.23 1.738 1.737 3.583-8.958-8.958 3.583 1.738 1.738-3.261 3.26C19.718 4.296 6.155 7.485 5.564 7.593l-1.738.466.896 3.476 1.415-.359 12.237 12.22-5.697 5.697H9.2l-5.375 5.375 3.583 1.792 1.792 3.583 5.375-5.375v-3.476l5.697-5.697 12.22 12.237-.34 1.415 3.457.896.466-1.738c.107-.591 3.297-14.154-4.999-23.614l3.26-3.26ZM8.305 10.78c3.673-.502 12.148-.896 18.329 4.354l-7.006 7.005L8.305 10.781Zm24.582 24.582L21.527 24.04l7.006-7.006c5.25 6.181 4.855 14.656 4.354 18.329Z"
    />
  </svg>
)
export default RPG